export enum coveragesRoutes {
  allCoverages = 'all-coverages',
  coverageDetails = 'coverage-details',
  coverageReceivOrders='coverage-Received-Orders',
  coverageGuards='coverage-Guards'
}
